<template>
  <div style="text-align: left; margin-left: 20px;">
    <div style="margin-top: 10px;">
        <span type="label">Heading</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.inventoryMaster.props.estore_title"
            style="width: 700px;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Sub-Heading</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.inventoryMaster.props.estore_sub_title"
            style="width: 700px;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Other Detail</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            type="textarea"
            :rows="5"
            v-model="$store.state.inventoryMaster.props.estore_other_detail"
            style="width: 100%;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Featuring Title</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            v-model="$store.state.inventoryMaster.props.estore_featuring_title"
            style="width: 700px;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Featuring Content</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            type="textarea"
            :rows="5"
            v-model="$store.state.inventoryMaster.props.estore_featuring_content"
            style="width: 100%;">
        </el-input>
    </div>
    <div style="margin-top: 10px;">
        <span type="label">Overview</span>
        <br>
        <el-input @focus="$event.target.select()"
            size="small"
            type="textarea"
            :rows="10"
            v-model="$store.state.inventoryMaster.props.estore_overview"
            style="width: 100%;">
        </el-input>
    </div>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/InventoryMaster/Form/EStore/Basic.vue